import base64url from 'base64url';
function compileCheckID(schema, parentSchema, it) {
    const length = schema;
    const b64min = Math.ceil((4 * length) / 3);
    const b64max = Math.ceil((4 * length) / 3) + 3;
    // this should probably be:
    // macro:
    // length, "multipleOf": 3
    // "pattern": regex for base64url
    const ajvError = function ajvError(message, instancePath) {
        return {
            message,
            keyword: 'uid',
            params: {
                keyword: 'uid'
            },
            instancePath: !instancePath ? '' : instancePath,
            schemaPath: it.errSchemaPath
        };
    };
    const validate = function validateID(uid, dataCxt) {
        validate.errors = [];
        // check length of encoded string
        if (uid.length < b64min || uid.length > b64max) {
            validate.errors.push(ajvError(`length must be between ${b64min} and ${b64max}, but is ${uid.length}`, dataCxt?.instancePath));
            return false;
        }
        // check id decodes to expected length
        // failures to decode return empty buffers, they don't seem to throw errors
        const decoded = base64url.toBuffer(uid);
        if (decoded.length !== length) {
            validate.errors.push(ajvError(`must decode to ${length} bytes`, dataCxt?.instancePath));
            return false;
        }
        // base64url decodes 'AAAAAAAAAAAAAA' and 'AAAAAAAAAAAAAK' to the same Buffer
        // (10 bytes of 00). This is because we used a key length that isn't divisble
        // by 3. You end up with bits at the end that are meaningless, never good.
        // We'll leave this for now but we should move to multiples of 3 before launch.
        // Then we can remove this check.
        //
        // It's not desirable to have keys that map to each other so we'll only acccept
        // IDs that encode/decode back to their cannonical form (cannonical: with padding
        // '=' removed)
        const encoded = base64url.encode(decoded);
        const ec = trimEquals(encoded);
        const ep = trimEquals(uid);
        if (ec !== ep) {
            validate.errors.push(ajvError('encoding is ambiguous', dataCxt?.instancePath));
            return false;
        }
        return true;
    };
    return validate;
}
function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
}
export const uid = {
    keyword: 'uid',
    type: 'string',
    compile: compileCheckID,
    errors: true,
    metaSchema: {
        title: 'ID bytes',
        description: 'number of bytes in ID',
        type: 'number',
        // min, max
        // "multipleOf": 3
    }
};
//# sourceMappingURL=uid.js.map